module.exports = __webpack_public_path__ + "static/media/galerija_2013 (7).93ad5d2f.jpg";